import { FC } from 'react';
import { Typography } from 'antd';
import { useGetApplication } from '~/controllers/wizard';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import { DocumentInput } from '~/components';
import { useTranslation } from 'react-i18next';
import buildNamePath from '~/utils/buildNamePath';
import ReviewItemCheckbox from '../../components/ReviewItemCheckbox';

const n = buildNamePath('reviewShareholders');

const ShareholdersProofs: FC = () => {
  const { t } = useTranslation('ksaReview');

  const applicationQuery = useGetApplication();
  const application = useGetApplication();
  const payload = application.data?.payload;

  const shareholders = applicationQuery?.data?.payload?.shareholders as KsaShareholders;
  const proof = shareholders?.proof;
  const minutesOfBoardMeetings = shareholders?.minutesOfBoardMeetings;
  const jointStockCompaniesData = shareholders?.jointStockCompaniesData;
  return (
    <>
      {payload?.proofRequired && (
        <>
          <Typography.Title level={4}>
            {t('Shareholder Proof Document').toUpperCase()}
          </Typography.Title>
          <ReviewItemCheckbox name={n(['proof'])} label={proof?.type ? t(proof?.type) : ''}>
            <div onClick={(e) => e.preventDefault()} aria-hidden>
              <DocumentInput
                name=""
                maxCount={proof?.files?.length}
                value={proof?.files}
                noRemove
                multiple={false}
                disabled
              />
            </div>
          </ReviewItemCheckbox>
        </>
      )}
      {payload?.minutesOfBoardMeetingsRequired && (
        <>
          <Typography.Title level={4}>
            {t('Minutes of board meetings').toUpperCase()}
          </Typography.Title>
          <ReviewItemCheckbox name={n(['minutesOfBoardMeetings'])} label="">
            <div onClick={(e) => e.preventDefault()} aria-hidden>
              <DocumentInput
                name=""
                maxCount={minutesOfBoardMeetings?.files?.length}
                value={minutesOfBoardMeetings?.files}
                noRemove
                multiple={false}
                disabled
              />
            </div>
          </ReviewItemCheckbox>
        </>
      )}
      {payload?.jointStockCompaniesDataRequired && (
        <>
          <Typography.Title level={4}>
            {t('Data of joint-stock companies listed in the financial market').toUpperCase()}
          </Typography.Title>
          <ReviewItemCheckbox name={n(['jointStockCompaniesData'])} label="">
            <div onClick={(e) => e.preventDefault()} aria-hidden>
              <DocumentInput
                name=""
                maxCount={jointStockCompaniesData?.files?.length}
                value={jointStockCompaniesData?.files}
                noRemove
                multiple={false}
                disabled
              />
            </div>
          </ReviewItemCheckbox>
        </>
      )}
    </>
  );
};

export default ShareholdersProofs;
